import './FilterBar.css'

import type { ReactNode } from 'react'

import { cx } from '../utilities/cx'

export type FilterBarProps = {
  className?: string
  children: ReactNode
}

export const FilterBar = (props: FilterBarProps) => {
  const { className, children } = props

  return <div className={cx('filter-bar', className)}>{children}</div>
}
